import { render, staticRenderFns } from "./charge.vue?vue&type=template&id=53115584&scoped=true"
import script from "./charge.vue?vue&type=script&lang=js"
export * from "./charge.vue?vue&type=script&lang=js"
import style0 from "./charge.vue?vue&type=style&index=0&id=53115584&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53115584",
  null
  
)

export default component.exports